import Container from "../components/Container/Container";
import Info from "./components/Info/Info";
import Blocks from "./components/Blocks/Blocks";
import Content from "./components/Content/Content";
import Description from "./components/Description/Description";
import Contact from "../components/Container/components/Contact/Contact";
import Floor from "../components/Container/components/Floor/Floor";

const Main = () => {
    return (
            <Container>
                <Info/>
                <Blocks/>
                <Content/>
                <Description/>
                <Contact/>
                <Floor/>
            </Container>
    )
}

export default Main